import React, { useState } from 'react';
import { Alert, Box, TextField } from '@mui/material';

const EmployeeHireWithdraw = ({ employee, onValidChange }) => {
  const [formData, setFormData] = useState({
    reason: ''
  });

  const [touched, setTouched] = useState({
    reason: false
  });

  const handleInputChange = (field) => (event) => {
    const newFormData = {
      ...formData,
      [field]: event.target.value
    };
    setFormData(newFormData);
    setTouched(prev => ({
      ...prev,
      [field]: true
    }));

    // Valid if reason is provided
    const isValid = event.target.value.trim().length > 0;
    onValidChange(isValid, newFormData);
  };

  const shouldShowError = (field) => {
    return touched[field];
  };

  React.useEffect(() => {
    // Initialize as invalid
    onValidChange(false, formData);
  }, []);

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 2 }}>
        <Alert severity="warning">
          This <strong>cancels the hire</strong>: every contract that has not started is
          voided and the person becomes <em>cancelled</em>. They can return later through
          <em> Rehire</em>.
          {employee?.hasPendingResignation && (
            <> The scheduled <strong>contract end is withdrawn in the same step</strong>, so
            nothing is left for the scheduler to enact.</>
          )}
        </Alert>
        <TextField
          fullWidth
          label="Reason"
          value={formData.reason}
          onChange={handleInputChange('reason')}
          multiline
          rows={4}
          required
          error={shouldShowError('reason') && !formData.reason}
          helperText={shouldShowError('reason') && !formData.reason
            ? 'Reason is required'
            : 'Reason for withdrawing the pending hire'}
          placeholder="Enter reason for withdrawal..."
        />
      </Box>
    </Box>
  );
};

export default EmployeeHireWithdraw;
